import { OrderType } from 'graphql-api/baskets-api-interfaces';

export function isOverwrittenDiscount(
  isManualDiscountApplied: boolean,
  isCloseOutProduct: boolean,
  orderType?: OrderType,
) {
  return (
    isManualDiscountApplied && isCloseOutProduct && orderType === OrderType.Now
  );
}
